import { debounce, mediaBreakpoints } from '../utils'
import { getElement } from '../utils/functional'

export default class HeroHeight {
  constructor (el) {
    this.els = {
      el,
      mobileNav: getElement('.hd-Mobile'),
      image: getElement(
        '.hro-HomeSlide, .hro-DoctorsSlide, .hro-HollywoodSlide, .hro-CollectionSlide',
        { context: el }
      )
    }

    this.mobileNavHeight = this.els.mobileNav.offsetHeight
    let windowWidth = ''

    const setImageHeight = () => {
      if (windowWidth !== window.innerWidth) {
        windowWidth = window.innerWidth

        this.els.image.style.height = `${window.innerHeight}px`
      }
    }

    setImageHeight()

    window.addEventListener('resize', debounce(setImageHeight, 100))
  }
}
